export default "__VITE_ASSET__DM572Od1__"